import React from "react";
import classnames from "classnames";

import QuickFilterPillStyles from "./QuickFilterPill.module.scss";

export interface QuickFilterPillProps<T> {
    text?: string;
    prefix?: JSX.Element;
    suffix?: JSX.Element;
    isMobile?: boolean;
    className?: string;
    selectedClassName?: string;
    prefixClassName?: string;
    suffixClassName?: string;
    isSelected?: boolean;
    isChecked?: number;
    onSelected?: (selectedItem: T) => void;
    onDeselected?: (item: T) => void;
    data?: T;
}

function QuickFilterPill<T>({
    text,
    prefix,
    suffix,
    isMobile,
    className,
    selectedClassName,
    prefixClassName,
    suffixClassName,
    isSelected = false,
    onSelected,
    onDeselected,
    data
}: QuickFilterPillProps<T>) {
    const _onSelected = () => {
        onSelected?.(data as any);
    };

    const _onDeselected = () => {
        onDeselected?.(data as any);
    };

    return (
        <div
            className={classnames(
                QuickFilterPillStyles.container,
                isSelected && QuickFilterPillStyles.selected,
                isSelected && selectedClassName,
                isMobile ? QuickFilterPillStyles.mobile : QuickFilterPillStyles.desktop,
                className
            )}
            onClick={isSelected ? _onDeselected : _onSelected}
        >
            {prefix && <span className={classnames(QuickFilterPillStyles.prefix, prefixClassName)}>{prefix}</span>}
            {text && <span className="quickFilterPill__text">{text}</span>}
            {suffix && <span className={classnames(QuickFilterPillStyles.suffix, suffixClassName)}>{suffix}</span>}
        </div>
    );
}

export default QuickFilterPill;
